import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import { Row, Col } from 'react-bootstrap';

import DrawingTable from './SweepstakeDetails/DrawingTable';

import { BoxedContent } from 'sg-ui-components';

import './SweepstakeDetails/style.scss';
export class SweepstakeDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { selectedSweep } = this.props;
        if (!selectedSweep) return null;
        const image = selectedSweep?.extra?.image ?? null;
        const description = selectedSweep?.extra?.description ?? null;
        const drawings = selectedSweep?.drawing_groups ?? null;
        const prizes = selectedSweep?.drawing_groups?.[0] ? selectedSweep.drawing_groups?.[0].prizes : null;
        const faqs = selectedSweep?.extra?.faqs ?? null;
        const rules = selectedSweep?.extra?.rules ?? null;

        //? For debug: console.log('🎁 Sweepstake details data:', { "sweepID" : preselection.sweepId , "sweep data" : sweep , "prizes_data" : prizes });

        return (
            <div>
                <div id='promotion-page-title'>
                    {image ? (
                        <Row>
                            <Col lg={4} className='my-3'>
                                <img src={selectedSweep?.extra?.image ?? null} alt={selectedSweep?.name} className='w-100 rounded-image' />
                            </Col>
                            <Col lg={8} className='my-3'>
                                <h3>{selectedSweep.name}</h3>
                                <div dangerouslySetInnerHTML={{ __html: description }}></div>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col lg={12} className='my-3'>
                                <h3>{selectedSweep.name}</h3>
                                <div dangerouslySetInnerHTML={{ __html: description }}></div>
                            </Col>
                        </Row>
                    )}
                </div>

                {prizes && (
                    <div className='promotion-page-section my-4'>
                        <BoxedContent note='Prizes section' hash='prizes' isActive={true} title='Prizes' variant='theme-black'>
                            {drawings.map((thisDrawingGroup) => {
                                return (
                                    <>
                                        {thisDrawingGroup.prizes.map((prize_item, index) => {
                                            const prize_image = prize_item?.extra?.image ?? null;
                                            const prize_description = prize_item?.extra?.description ?? null;
                                            return (
                                                <div key={index} className='prize-content my-4 mx-md-5'>
                                                    <h3 className='prizes-tier'>{prize_item?.tier}</h3>
                                                    {prize_image ? (
                                                        <Row>
                                                            <Col lg={4} className='my-3'>
                                                                <div className='prize-img-container'>
                                                                    <img src={prize_image} alt={prize_description} className='img-fluid prize-img' />
                                                                </div>
                                                            </Col>
                                                            <Col lg={8} className='my-lg-3 pt-4'>
                                                                <h4 className='prizes-title'>{prize_item?.name}</h4>
                                                                <h5 className='prizes-winner'>
                                                                    {prize_item?.quantity} {prize_item?.quantity > 1 ? 'Winners' : 'Winner'}
                                                                </h5>
                                                                <div className='prizes-description' dangerouslySetInnerHTML={{ __html: prize_description }} />
                                                            </Col>
                                                        </Row>
                                                    ) : (
                                                        <Row>
                                                            <Col lg={12} className='my-3'>
                                                                <h4 className='prizes-title'>{prize_item?.name}</h4>
                                                                <h5 className='prizes-winner'>
                                                                    {prize_item?.quantity} {prize_item?.quantity > 1 ? 'Winners' : 'Winner'}
                                                                </h5>
                                                                <div dangerouslySetInnerHTML={{ __html: prize_description }} />
                                                            </Col>
                                                        </Row>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </>
                                );
                            })}
                        </BoxedContent>
                    </div>
                )}

                <div className='promotion-page-section my-5'>
                    <BoxedContent note='Drawings section' hash='drawings' isActive={true} title='Drawings' variant='theme-black'>
                        <DrawingTable drawings={drawings} />
                    </BoxedContent>
                </div>

                {faqs && (
                    <div className='promotion-page-section my-5'>
                        <BoxedContent
                            note='FAQ section'
                            hash='faq'
                            variant='theme-black'
                            isActive={true}
                            title={
                                <>
                                    FAQ<span className='lowercase'>S</span>
                                </>
                            }>
                            <div className='mobile-container' dangerouslySetInnerHTML={{ __html: faqs }}></div>
                        </BoxedContent>
                    </div>
                )}

                {rules && (
                    <div className='promotion-page-section my-5'>
                        <BoxedContent note='Rules section' hash='rules' isActive={true} title='Rules' variant='theme-black'>
                            <div className='mobile-container' dangerouslySetInnerHTML={{ __html: rules }}></div>
                        </BoxedContent>
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SweepstakeDetails);
